import { Suspense, useEffect } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { Grid, Box, Button, styled } from "@mui/material";
import BugImage from "@/src-refactor/assets/images/bug-fixing.svg?react";
import Screenshot from "@/src-refactor/assets/images/screenshot.svg?react";
import User from "@/src-refactor/assets/images/profile.svg?react";
import Actions from "@/src-refactor/assets/images/actions.svg?react";
import MxDetailLayoutMain from "@rf-l1/page/details/MxDetailLayoutMain";
import MxTypography from "@rf-l1/MxTypography";

function ErrorBoundaryComponent({
  suspendComponent,
  children
}: IErrorBoundaryComponent) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={suspendComponent}>{children}</Suspense>
    </ErrorBoundary>
  );
}

function clickWhatsApp() {
  window.open("https://wa.me/+18093304948", "_blank");
}

export default ErrorBoundaryComponent;

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  useEffect(() => {
    console.log("ErrorBoundaryComponent", error);
  }, [error.message]);

  return (
    <MxDetailLayoutMain
      bgcolor="background.default"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Grid container gap={2}>
        <Grid item xs={12}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ "& svg": { width: "13rem", height: "13rem" } }}
          >
            <BugImage />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MxTypography variant="subtitle1" color="primary.main" align="center">
            Upss... Ha ocurrido un inconveniente.
          </MxTypography>
        </Grid>
        <Grid item xs={12}>
          <MxTypography variant="subtitle2" color="grey.600" align="center">
            Comunícate con la Mesa de Ayuda y, para optimizar el servicio, ten en
            cuenta lo siguiente:
          </MxTypography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          container
          spacing={2}
          mt={1}
          mx="auto"
        >
          <ActionsCard
            icon={Screenshot}
            text="Tomar una captura de tu pantalla completa"
          />
          <ActionsCard
            icon={User}
            text="Provee tu nombre completo y tipo de usuario"
          />
          <ActionsCard icon={Actions} text="Notifica qué acción intentabas hacer" />
        </Grid>
        <Grid container item xs={12} justifyContent="center" gap={0.6}>
          <StyledButton onClick={resetErrorBoundary}>Intente otra vez</StyledButton>
          <StyledButtonWS onClick={clickWhatsApp}>Mesa de ayuda</StyledButtonWS>
        </Grid>
      </Grid>
    </MxDetailLayoutMain>
  );
}

interface IErrorBoundaryComponent {
  suspendComponent: JSX.Element;
  children: any;
}

function ActionsCard({ icon: Icon, text }: { icon: any; text: string }) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        bgcolor="#f4f4f4db"
        borderRadius="1rem"
        p={1.6}
        alignItems="center"
        textAlign="center"
        height="100%"
        sx={{ overflowY: "hidden" }}
      >
        <Icon style={{ width: "5rem", height: "5rem" }} />
        <MxTypography color="#3f3f3f" fontWeight={400}>
          {text}
        </MxTypography>
      </Box>
    </Grid>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "1.3rem",
  marginBottom: "1.2rem",
  textTransform: "none",
  fontWeight: 400,
  color: "#fff",
  backgroundColor: "#1a3668",
  padding: "0.3rem 1.2rem",
  borderRadius: "1.8rem",
  fontSize: "1rem",

  "&:hover": {
    backgroundColor: "#071326"
  }
}));

const StyledButtonWS = styled(Button)(({ theme }) => ({
  marginTop: "1.3rem",
  marginBottom: "1.2rem",
  textTransform: "none",
  fontWeight: 400,
  backgroundColor: "#19c558",
  color: "#fff",
  padding: "0.3rem 1.2rem",
  borderRadius: "1.8rem",
  fontSize: "1rem",

  "&:hover": {
    backgroundColor: "#1a994a"
  }
}));
